import { takeLatest, call, put } from "redux-saga/effects";
import {
  partnerLogoDeleted,
  PARTNER_LOGO_DELETE_REQUEST,
  partnerLogoDeleteError,
} from "../../actions/partners";
import uploadLogo from "../../../../../backend/oncall/administration/partners/remove-logo";

const requestDelete = function*(action) {
  try {
    yield call(uploadLogo, parseInt(action.payload.partnerId, 10));
    yield put(partnerLogoDeleted());
  } catch (error) {
    yield put(partnerLogoDeleteError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(PARTNER_LOGO_DELETE_REQUEST, requestDelete);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/partners/request-delete-logo.js